import React, { useCallback, useEffect, useState } from "react";
import { useCompany } from "../../context/CompanyContext";
import { getCRMStats } from "../services/crmDashboardService";
import CRMDashboardCharts from "../components/CRMDashboardCharts";
import "../styles/crm.css";

const CRMDashboard = () => {
  const { companyId } = useCompany();
  const [data, setData] = useState(null);
  const [message, setMessage] = useState("");

  const load = useCallback(async () => {
    if (!companyId) return;

    setMessage("");

    try {
      const result = await getCRMStats(companyId);
      setData(result);
    } catch (error) {
      setMessage(error.message || "Failed to load CRM dashboard");
    }
  }, [companyId]);

  useEffect(() => {
    load();
  }, [load]);

  if (!data) {
    return (
      <div className="crm-message">{message || "Loading dashboard..."}</div>
    );
  }

  return (
    <div>
      {message ? <div className="crm-message">{message}</div> : null}

      <div className="crm-grid">
        <div className="crm-kpi-card">
          <p className="crm-kpi-title">Total Leads</p>
          <h3 className="crm-kpi-value">{data.kpis.totalLeads}</h3>
        </div>

        <div className="crm-kpi-card">
          <p className="crm-kpi-title">Converted Leads</p>
          <h3 className="crm-kpi-value">{data.kpis.convertedLeads}</h3>
        </div>

        <div className="crm-kpi-card">
          <p className="crm-kpi-title">Lead Conversion Rate</p>
          <h3 className="crm-kpi-value">
            {data.kpis.conversionRate.toFixed(1)}%
          </h3>
        </div>

        <div className="crm-kpi-card">
          <p className="crm-kpi-title">Pipeline Value</p>
          <h3 className="crm-kpi-value">
            ₦{Number(data.kpis.pipelineValue || 0).toLocaleString()}
          </h3>
        </div>

        <div className="crm-kpi-card">
          <p className="crm-kpi-title">Weighted Forecast</p>
          <h3 className="crm-kpi-value">
            ₦{Number(data.kpis.weighted || 0).toLocaleString()}
          </h3>
        </div>

        <div className="crm-kpi-card">
          <p className="crm-kpi-title">Quote Value</p>
          <h3 className="crm-kpi-value">
            ₦{Number(data.kpis.quoteValue || 0).toLocaleString()}
          </h3>
        </div>

        <div className="crm-kpi-card">
          <p className="crm-kpi-title">Sent Quotes</p>
          <h3 className="crm-kpi-value">{data.kpis.sentQuotes}</h3>
        </div>

        <div className="crm-kpi-card">
          <p className="crm-kpi-title">Accepted Quotes</p>
          <h3 className="crm-kpi-value">{data.kpis.acceptedQuotes}</h3>
        </div>

        <div className="crm-kpi-card">
          <p className="crm-kpi-title">Outstanding Receivables</p>
          <h3 className="crm-kpi-value">
            ₦{Number(data.kpis.outstandingReceivables || 0).toLocaleString()}
          </h3>
        </div>

        <div className="crm-kpi-card">
          <p className="crm-kpi-title">Open Collections</p>
          <h3 className="crm-kpi-value">{data.kpis.openCollections}</h3>
        </div>

        <div className="crm-kpi-card">
          <p className="crm-kpi-title">Stale Deals</p>
          <h3 className="crm-kpi-value">{data.kpis.staleDeals}</h3>
        </div>

        <div className="crm-kpi-card">
          <p className="crm-kpi-title">Overdue Activities</p>
          <h3 className="crm-kpi-value">{data.kpis.overdueActivities}</h3>
        </div>
      </div>

      <CRMDashboardCharts charts={data.charts} />
    </div>
  );
};

export default CRMDashboard;
